export default "__VITE_ASSET__kmFDRrRV__"